import { PAL } from "../platform/PlatformAdapters";
export class Mouse {
    static set cursor(value) {
        this._cursor = value;
        if (this._hidden)
            return;
        PAL.browser.setCursor(value);
    }
    static get cursor() {
        return this._cursor;
    }
    static hide() {
        this._hidden = true;
        PAL.browser.setCursor("none");
    }
    static show() {
        this._hidden = false;
        PAL.browser.setCursor(this._cursor);
    }
}
Mouse._cursor = "auto";
Mouse._hidden = false;
